import { useCallback, useState } from "react";
import { lazyWithPreload } from "utils/lazyWithPreload";

import { usePreloadComponents } from "hooks/usePreloadedComponents";

const PrivateLinkCreate = lazyWithPreload(() => import("./PrivateLinkCreate"));

export const usePrivateLink = () => {
  const [open, setOpen] = useState<boolean>(false);

  usePreloadComponents([PrivateLinkCreate]);

  const openPrivateLinkForm = useCallback((onOpen: () => void) => {
    onOpen();
    setOpen(true);
  }, []);

  const closePrivateLinkForm = useCallback(() => {
    setOpen(false);
  }, []);

  let privateLinkMarkup = null;

  if (open) {
    privateLinkMarkup = <PrivateLinkCreate onClose={closePrivateLinkForm} />;
  }

  return {
    openPrivateLinkForm,
    closePrivateLinkForm,
    privateLinkMarkup,
  };
};
